import React from "react";
import Quiz from './components/Quiz'
import './App.css'

function App() {
  return (
    
  
        <div>
            <Quiz />
        </div>
   
    

  );
}

export default App;
